"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isOverclaimAllowed = void 0;
const dayjs_1 = __importDefault(require("dayjs"));
const isOverclaimAllowed = (workDraft) => {
    const dateThreeMonthsAgo = (0, dayjs_1.default)(new Date()).subtract(90, 'days').utc();
    if (workDraft === null || workDraft === void 0 ? void 0 : workDraft.createdDate) {
        const registrationDate = (0, dayjs_1.default)(workDraft === null || workDraft === void 0 ? void 0 : workDraft.createdDate).utc();
        return registrationDate.isAfter(dateThreeMonthsAgo);
    }
    return !isWorkOverclaimView(workDraft);
};
exports.isOverclaimAllowed = isOverclaimAllowed;
const isWorkOverclaimView = (workDraft) => !!(workDraft && workDraft.workType === 'overclaim');
